import { weekDay as weekDayFormat } from '@/helpers/dateTimeFormats';

const weekDayFormatter = new Intl.DateTimeFormat(undefined, weekDayFormat);

export default function formatWeekDay(dateTime) {
  if (!dateTime) return '';
  return weekDayFormatter.format(dateTime);
}
